import '../../polyfills';
import '@payhoa/ui-kit/elements';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from '../../environments/environment';
import { AppModule } from '../../app/app.module';
import { hmrBootstrap } from '../../hmr';
import { stripSensitiveRouteParams } from '../../app/services/auth/sensitive-route-params';

if (environment.useProdMode) {
    enableProdMode();
}

// SD-7666: the SD-7544 blanket override of ALL console methods in prod was
// removed. Console behavior is back to its pre-SD-7544 state; keeping RAW
// uncaught-error detail out of the production console is now handled narrowly by
// GlobalErrorHandler (which swallows the raw error in prod and echoes it to the
// console only in dev), instead of silencing every console method app-wide.
// NOTE: the SD-7544 Better Stack [ClientError] reporting feed was also removed in
// this PR — GlobalErrorHandler performs NO backend reporting.

// SD-10682: take the password reset token out of the address bar before GTM (added in
// GtmService's constructor at boot) can read document.location for its tags.
stripSensitiveRouteParams();

const bootstrap = () => {
    return platformBrowserDynamic().bootstrapModule(AppModule);
};

if (environment.hmr) {
    if (module['hot']) {
        hmrBootstrap(module, bootstrap);
    } else {
        console.error('HMR is not enabled for webpack-dev-server!');
        console.log('Are you using the --hmr flag for ng serve?');
    }
} else {
    bootstrap();
}
